import React from "react"
import {classNames} from "js/studios/shared/utils"

export function ProgressBar({percent, className}) {
  return <div className={classNames("outer_bar", className)}>
    <div className="progress" style={{width: `${Math.max(15, percent)}%`}}></div>
  </div>
}
